import masqueradeStore from './Masquerade.store';

/**
 * The masquerade identity a classrooms query is scoped to.
 *
 * Callers that build the query **during render** pass this in, bridged with `useFluxStore`, so a
 * React-Compiler-memoized component still re-renders when the masquerade changes. Callers outside
 * render (event handlers, effects) omit it and the store is read directly.
 */
export interface MasqueradeScope {
  /** The teacher whose classrooms to read — `masqueradeStore.getUserIdByMasqueradeState()`. */
  teacherId: string | null | undefined;
  /** `masqueradeStore.getSchoolId()` while masquerading, otherwise `null`. */
  schoolId: string | null;
}

/** The current masquerade scope, read straight from the store. Render callers bridge each field
 *  with `useFluxStore` instead. */
export function readMasqueradeScope(): MasqueradeScope {
  return {
    teacherId: masqueradeStore.getUserIdByMasqueradeState(),
    schoolId: masqueradeStore.isMasquerading() ? masqueradeStore.getSchoolId() : null
  };
}

/**
 * Scopes a classrooms filter to the masquerade school; a no-op when not masquerading.
 *
 * A masquerading admin can only read classrooms at the school they masqueraded into, and the API
 * rejects the whole list (403) when a multi-school teacher's other classrooms are included.
 */
export function masqueradeSchoolFilter(schoolId: string | null) {
  return schoolId ? {school_v5: schoolId} : {};
}
